@if (inputData.type !== 'stages' && inputData.type !== 'invoice_info') {
  <div
    class="modal-content border-0 cnt-dashboard border-r2"
    data-backdrop="static"
  >
    <h2 class="text-1 fs-4 text-center mb-3">
      {{ 'QUOTE_TEMPLATE.Clone Quote' | translate }}
    </h2>

    <mat-radio-group
      aria-labelledby="example-radio-group-label"
      class="example-radio-group text-center w-full"
      style="display: flex; flex-direction: column; align-items: center"
      color="primary"
      [(ngModel)]="selectedOption"
    >
      <mat-radio-button
        class="example-radio-button mt-3"
        [value]="'sameContact'"
      >
        {{ 'QUOTE_TEMPLATE.Clone quote with current contact' | translate }}
      </mat-radio-button>
      <mat-radio-button
        class="example-radio-button mt-3"
        [value]="'newContact'"
      >
        {{ 'QUOTE_TEMPLATE.Clone quote new a contact' | translate }}
      </mat-radio-button>
    </mat-radio-group>

    @if (
      selectedOption == 'newContact' &&
      inputData.type !== 'stages' &&
      inputData.type !== 'invoice_info'
    ) {
      <div>
        <div
          class="w-full flex flex-col items-center justify-center"
          style="margin-top: 40px"
        >
          <mat-select
            #selectDropdown
            id="contact_quote"
            class="form-control p-2 text-center fs-14"
            name="name"
            placeholder="{{ 'COMMON.Select_Contact' | translate }}"
            style="
              width: 75% !important;
              border-right: none;
              border-left: none;
              border-top: none;
              border-radius: 0;
            "
            [(ngModel)]="selectedContact"
            (appMatSelectScrollBottom)="loadAllOnScroll(currentPage)"
            (click)="onSelectionChange($event)"
          >
            <!-- (keyup)="onKeySearch($event)" [value]="globalSearchText" value="{{globalSearchText}}" -->
            <input
              #searchInput
              name=""
              id="searchInput"
              placeholder="{{
                'QUOTE_TEMPLATE.Enter Contact Name...' | translate
              }}"
              type="text"
              style="
                width: 100%;
                height: 50px;
                border: none;
                padding-left: 18px;
                position: sticky;
                top: 0px;
                z-index: 9999;
              "
              (keyup)="onKeySearch($event)"
              [value]="globalSearchText"
              value="{{ globalSearchText }}"
            />
            @if (resetSearch) {
              <p
                (click)="clearSearch()"
                class="position-absolute input-group-icon border-start-0 text-6"
                style="right: 12px !important; top: 16px !important"
              >
                <a href="javascript:void(0)" class="cursor-pointer">✕</a>
              </p>
            }
            <mat-option value="">{{ 'COMMON.Select' | translate }}</mat-option>
            <!-- Use *ngFor to loop through an array of contact names -->

            <!-- Use *ngFor to loop through an array of contact names -->
            @for (contactName of merContactListArr; track contactName) {
              <mat-option
                style="margin-top: 15px; margin-bottom: 15px"
                [value]="contactName"
              >
                <img
                  [src]="getImage(contactName?.profile_photo, 'contact')"
                  style="
                    height: 3rem;
                    width: 3rem;
                    border-radius: 100%;
                    object-fit: cover;
                  "
                />
                <span [innerHTML]="highlightMatch(contactName.firstname)"></span
                >&nbsp;<span
                  [innerHTML]="highlightMatch(contactName.lastname)"
                ></span>
              </mat-option>
            }
          </mat-select>

          @if (categoryAddModel.title && merContactListArr?.length) {
            <div class="flex flex-col justify-center items-center mt-3">
              <img
                [src]="
                  getImage(categoryAddModel.title.profile_photo, 'contact')
                "
                style="
                  height: 4rem;
                  width: 4rem;
                  border-radius: 100%;
                  object-fit: cover;
                "
              />
              <div
                style="
                  color: #92a0a8;
                  font-size: 16px;
                  font-weight: 500;
                  margin-top: 5px;
                "
              >
                {{ categoryAddModel.title.firstname }}
                {{ categoryAddModel.title.lastname }}
              </div>
            </div>
          }
          @if (!merContactListArr?.length) {
            <div class="flex flex-col justify-center items-center mt-3">
              <p>
                {{
                  'QUOTE_TEMPLATE.You do not have any contacts. Add one by clicking'
                    | translate
                }}
                <a
                  (click)="closeDialog()"
                  [routerLink]="'/dash/contacts/add'"
                  >{{ 'COMMON.here' | translate }}</a
                >.
              </p>
            </div>
          }
        </div>
      </div>
    }

    @if (inputData.type !== 'stages' && inputData.type !== 'invoice_info') {
      <div class="flex justify-center mt-8">
        <div class="text-center">
          <button
            class="btn btn-skyblue-s-1 standard-btn mx-2"
            id=""
            (click)="closeModal()"
          >
            <!-- <i class="fas fa-arrow-left me-2"></i> -->
            {{ 'COMMON.Cancel' | translate }}
          </button>
        </div>
        <button
          class="btn btn-p-2 standard-btn mx-2"
          type="submit"
          (click)="cloneQuote()"
        >
          {{ 'COMMON.Clone' | translate }} &nbsp;
          <i class="fas fa-arrow-right me-2"></i>
        </button>
      </div>
    }
  </div>
}

@if (inputData.type == 'stages') {
  <div>
    <span class="flex relative justify-end">
      <i
        type="button"
        data-bs-dismiss="modal"
        aria-label="Close"
        (click)="closeDialog()"
        class="color-4 absolute fs-2 far fa-times-circle -top-[16px] -right-2.5 m-3"
        #closebutton
      ></i>
    </span>
    <h2 class="text-1 fs-4 text-center">
      {{ 'QUOTE_TEMPLATE.Quote Stages' | translate }}
    </h2>

    <div class="stage_option d-flex overflow-hidden pt-3" id="stage_list">
      <div #stageContainer class="d-flex stage_div gap-1 align-items-center">
        <div
          style="width: max-content; min-width: 251px !important"
          class="xs-7:!w-[270px]"
        >
          <div
            cdkDropList
            class="example-list d-flex flex-column scrollable-list-container"
            (cdkDropListDropped)="dropStages($event)"
            style="padding: 0px 18px"
          >
            @for (item of allQuoteStagesList; track item; let i = $index) {
              <div
                class="example-box"
                cdkDrag
                [cdkDragBoundary]="stageContainer"
                [cdkDragPreviewClass]="'custom-drag-preview'"
              >
                <div class="row align-items-center d-flex p-2 mb-1">
                  <div class="flex justify-between items-center">
                    <div
                      class="flex gap-2 items-center mr-2"
                      style="width: -webkit-fill-available"
                    >
                      <span
                        [style.visibility]="
                          item.name === 'Pending' ? 'hidden' : 'visible'
                        "
                        style="cursor: all-scroll"
                        role="button"
                        aria-label="expand row"
                        cdkDragHandle
                      >
                        <svg
                          width="22"
                          height="16"
                          viewBox="0 0 22 16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.970703"
                            y="0.199219"
                            width="20.0696"
                            height="1.64544"
                            rx="0.82272"
                            fill="#03c0fc"
                          />
                          <rect
                            x="0.970703"
                            y="6.78125"
                            width="20.0696"
                            height="1.64544"
                            rx="0.82272"
                            fill="#03c0fc"
                          />
                          <rect
                            x="0.970703"
                            y="13.3633"
                            width="20.0696"
                            height="1.64544"
                            rx="0.82272"
                            fill="#03c0fc"
                          />
                        </svg>
                      </span>
                      @if (permission?.includes('quoteStage_create')) {
                        <span
                          class="d-flex align-items-center border-gris p-2 col w-[230px] cursor-move overflow-hidden xs-7:!w-[165px]"
                        >
                          <!-- <span > -->
                          <p class="text-1 m-0 col">
                            {{
                              getTranslatedText('COMMON.' + item.name) ||
                                item.name
                            }}
                          </p>
                          <div
                            class="bg-2 rounded-2 p-2"
                            [ngStyle]="{ 'background-color': item.color }"
                          ></div>
                        </span>
                      }
                      <!-- </span> -->
                    </div>
                    <!-- <i class="fa fa-edit edit-icon mr-2 pointer" style="color: #03C0FC;" (click)="editQuoteStage(item)"></i> -->
                    <div class="w-28">
                      <img
                        role="button"
                        src="assets/img/home/pencil.svg"
                        (click)="editQuoteStage(item)"
                      />
                    </div>
                    <div class="w-28 text-center">
                      <a
                        type="button"
                        class="color-4"
                        style="font-size: 14px"
                        (click)="removeQuoteStage(item)"
                        ><b>✕</b></a
                      >
                    </div>
                  </div>
                </div>
                <ng-template cdkDragPreview>
                  <div class="flex justify-between items-center">
                    <div
                      class="flex gap-2 items-center mr-2"
                      style="width: -webkit-fill-available"
                    >
                      <span
                        [style.visibility]="
                          item.name === 'Pending' ? 'hidden' : 'visible'
                        "
                        style="cursor: all-scroll"
                        role="button"
                        aria-label="expand row"
                        cdkDragHandle
                      >
                        <svg
                          width="22"
                          height="16"
                          viewBox="0 0 22 16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.970703"
                            y="0.199219"
                            width="20.0696"
                            height="1.64544"
                            rx="0.82272"
                            fill="#03c0fc"
                          />
                          <rect
                            x="0.970703"
                            y="6.78125"
                            width="20.0696"
                            height="1.64544"
                            rx="0.82272"
                            fill="#03c0fc"
                          />
                          <rect
                            x="0.970703"
                            y="13.3633"
                            width="20.0696"
                            height="1.64544"
                            rx="0.82272"
                            fill="#03c0fc"
                          />
                        </svg>
                      </span>
                      @if (permission?.includes('quoteStage_create')) {
                        <span
                          class="d-flex align-items-center border-gris p-2 col w-[230px] cursor-move overflow-hidden"
                        >
                          <p class="text-1 m-0 col">
                            {{
                              getTranslatedText('COMMON.' + item.name) ||
                                item.name
                            }}
                          </p>
                          <div
                            class="bg-2 rounded-2 p-2"
                            [ngStyle]="{ 'background-color': item.color }"
                          ></div>
                        </span>
                      }
                    </div>
                    <div class="w-28">
                      <img
                        role="button"
                        src="assets/img/home/pencil.svg"
                        (click)="editQuoteStage(item)"
                      />
                    </div>
                    <div class="w-28 text-center">
                      <a
                        type="button"
                        class="color-4"
                        style="font-size: 14px"
                        (click)="removeQuoteStage(item)"
                        ><b>✕</b></a
                      >
                    </div>
                  </div>
                </ng-template>
              </div>
            }
          </div>
          @if (permission?.includes('quoteStage_create')) {
            <span
              class="d-flex align-items-center justify-content-center gap-3 cursor-pointer mt-3 mb-2"
              (click)="openDialogAddQuoteStage()"
            >
              <mat-icon class="!flex"> </mat-icon>
              <span
                class="font-medium text-[16px] text-[#03c0fc]"
                style="height: 1rem !important"
              >
                {{ 'COMMON.ADD_NEW_STAGE' | translate }}
              </span>
            </span>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (inputData.type == 'invoice_info') {
  <div>
    <div class="flex justify-end items-center">
      <svg
        width="20"
        height="20"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="closeDialog()"
        class="cursor-pointer"
      >
        <path
          d="M17.5 35C7.85038 35 0 27.1496 0 17.5C0 7.85038 7.85038 0 17.5 0C27.1496 0 35 7.85038 35 17.5C35 27.1496 27.1496 35 17.5 35ZM17.5 2.49992C9.22905 2.49992 2.49992 9.22905 2.49992 17.5C2.49992 25.771 9.22905 32.5001 17.5 32.5001C25.771 32.5001 32.5001 25.771 32.5001 17.5C32.5001 9.22905 25.771 2.49992 17.5 2.49992Z"
          fill="#F85050"
        />
        <path
          d="M23.7417 25.007C23.4218 25.007 23.1019 24.885 22.8579 24.6406L10.358 12.1407C9.8696 11.6523 9.8696 10.8614 10.358 10.3733C10.8461 9.88515 11.6373 9.88488 12.1255 10.3733L24.6253 22.8732C25.1137 23.3616 25.1137 24.1525 24.6253 24.6406C24.3813 24.885 24.0616 25.007 23.7417 25.007Z"
          fill="#F85050"
        />
        <path
          d="M11.2416 25.0071C10.9217 25.0071 10.6021 24.8851 10.358 24.6407C9.8696 24.1526 9.8696 23.3614 10.358 22.8733L22.8579 10.3734C23.3463 9.88498 24.1372 9.88498 24.6253 10.3734C25.1135 10.8615 25.1137 11.6527 24.6253 12.1408L12.1255 24.6407C11.8814 24.8851 11.5615 25.0071 11.2416 25.0071Z"
          fill="#F85050"
        />
      </svg>
    </div>
    <div class="stage_option flex flex-col overflow-hidden" id="stage_list">
      <div class="w-full flex justify-center items-center">
        <div class="d-flex stage_div gap-1 align-items-center">
          <div
            style="
              max-height: 250px;
              width: max-content;
              min-width: 251px !important;
            "
          >
            <div
              class="example-list d-flex flex-column scrollable-list-container"
              style="padding: 0px 18px"
            >
              @for (item of this.inputData?.data; track item; let i = $index) {
                <div class="example-box">
                  <div class="row align-items-center d-flex p-2 mb-1">
                    <span class="d-flex align-items-center">
                      <div
                        class="flex gap-4 flex-col justify-between w-full items-start"
                      >
                        <div>
                          <span style="margin-right: 10px">
                            <svg
                              width="24px"
                              height="24px"
                              viewBox="0 0 6.3500002 6.3500002"
                              id="svg1976"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:cc="http://creativecommons.org/ns#"
                              xmlns:dc="http://purl.org/dc/elements/1.1/"
                              xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                              xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                              xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                              xmlns:svg="http://www.w3.org/2000/svg"
                            >
                              <defs id="defs1970" />

                              <g id="layer1" style="display: inline">
                                <path
                                  d="m 4.8950508,3.7044845 c -0.6607016,0 -1.1895931,0.5283747 -1.1895931,1.1890748 0,0.66069 0.5288915,1.1916585 1.1895931,1.1916585 0.660699,0 1.1911413,-0.5309685 1.1911413,-1.1916585 0,-0.6607001 -0.5304423,-1.1890748 -1.1911413,-1.1890748 z M 4.6997142,4.3700769 A 0.2645835,0.2645835 0 0 1 4.9632631,4.6356937 V 4.8997603 H 5.2288809 A 0.2645835,0.2645835 0 0 1 5.4924297,5.1653774 0.2645835,0.2645835 0 0 1 5.2288809,5.428927 H 4.6997142 A 0.26460996,0.26460996 0 0 1 4.4340964,5.1653774 V 4.6356937 A 0.2645835,0.2645835 0 0 1 4.6997142,4.3700769 Z"
                                  id="path2452"
                                  style="
                                    color: #03c0fc;
                                    font-style: normal;
                                    font-variant: normal;
                                    font-weight: normal;
                                    font-stretch: normal;
                                    font-size: medium;
                                    line-height: normal;
                                    font-family: sans-serif;
                                    font-variant-ligatures: normal;
                                    font-variant-position: normal;
                                    font-variant-caps: normal;
                                    font-variant-numeric: normal;
                                    font-variant-alternates: normal;
                                    font-variant-east-asian: normal;
                                    font-feature-settings: normal;
                                    font-variation-settings: normal;
                                    text-indent: 0;
                                    text-align: start;
                                    text-decoration: none;
                                    text-decoration-line: none;
                                    text-decoration-style: solid;
                                    text-decoration-color: #03c0fc;
                                    letter-spacing: normal;
                                    word-spacing: normal;
                                    text-transform: none;
                                    writing-mode: lr-tb;
                                    direction: ltr;
                                    text-orientation: mixed;
                                    dominant-baseline: auto;
                                    baseline-shift: baseline;
                                    text-anchor: start;
                                    white-space: normal;
                                    shape-padding: 0;
                                    shape-margin: 0;
                                    inline-size: 0;
                                    clip-rule: nonzero;
                                    display: inline;
                                    overflow: visible;
                                    visibility: visible;
                                    isolation: auto;
                                    mix-blend-mode: normal;
                                    color-interpolation: sRGB;
                                    color-interpolation-filters: linearRGB;
                                    solid-color: #03c0fc;
                                    solid-opacity: 1;
                                    vector-effect: none;
                                    fill: #03c0fc;
                                    fill-opacity: 1;
                                    fill-rule: nonzero;
                                    stroke: none;
                                    stroke-width: 0.529167;
                                    stroke-linecap: round;
                                    stroke-linejoin: round;
                                    stroke-miterlimit: 4;
                                    stroke-dasharray: none;
                                    stroke-dashoffset: 0;
                                    stroke-opacity: 1;
                                    paint-order: stroke fill markers;
                                    color-rendering: auto;
                                    image-rendering: auto;
                                    shape-rendering: auto;
                                    text-rendering: auto;
                                    enable-background: accumulate;
                                    stop-color: #03c0fc;
                                  "
                                />

                                <path
                                  d="m 1.8519521,0.26478431 a 0.2645835,0.2645835 0 0 0 -0.26367,0.26367 V 1.0577543 a 0.2645835,0.2645835 0 0 0 0.26367,0.26562 0.2645835,0.2645835 0 0 0 0.26563,-0.26562 V 0.52845431 a 0.2645835,0.2645835 0 0 0 -0.26563,-0.26367 z"
                                  id="path712"
                                  style="
                                    color: #03c0fc;
                                    font-style: normal;
                                    font-variant: normal;
                                    font-weight: normal;
                                    font-stretch: normal;
                                    font-size: medium;
                                    line-height: normal;
                                    font-family: sans-serif;
                                    font-variant-ligatures: normal;
                                    font-variant-position: normal;
                                    font-variant-caps: normal;
                                    font-variant-numeric: normal;
                                    font-variant-alternates: normal;
                                    font-variant-east-asian: normal;
                                    font-feature-settings: normal;
                                    font-variation-settings: normal;
                                    text-indent: 0;
                                    text-align: start;
                                    text-decoration: none;
                                    text-decoration-line: none;
                                    text-decoration-style: solid;
                                    text-decoration-color: #03c0fc;
                                    letter-spacing: normal;
                                    word-spacing: normal;
                                    text-transform: none;
                                    writing-mode: lr-tb;
                                    direction: ltr;
                                    text-orientation: mixed;
                                    dominant-baseline: auto;
                                    baseline-shift: baseline;
                                    text-anchor: start;
                                    white-space: normal;
                                    shape-padding: 0;
                                    shape-margin: 0;
                                    inline-size: 0;
                                    clip-rule: nonzero;
                                    display: inline;
                                    overflow: visible;
                                    visibility: visible;
                                    isolation: auto;
                                    mix-blend-mode: normal;
                                    color-interpolation: sRGB;
                                    color-interpolation-filters: linearRGB;
                                    solid-color: #03c0fc;
                                    solid-opacity: 1;
                                    vector-effect: none;
                                    fill: #03c0fc;
                                    fill-opacity: 1;
                                    fill-rule: nonzero;
                                    stroke: none;
                                    stroke-width: 0.529167;
                                    stroke-linecap: round;
                                    stroke-linejoin: miter;
                                    stroke-miterlimit: 4;
                                    stroke-dasharray: none;
                                    stroke-dashoffset: 0;
                                    stroke-opacity: 1;
                                    color-rendering: auto;
                                    image-rendering: auto;
                                    shape-rendering: auto;
                                    text-rendering: auto;
                                    enable-background: accumulate;
                                    stop-color: #03c0fc;
                                  "
                                />

                                <path
                                  d="m 4.2328121,0.26478431 a 0.2645835,0.2645835 0 0 0 -0.26367,0.26367 V 1.0577543 a 0.2645835,0.2645835 0 0 0 0.26367,0.26562 0.2645835,0.2645835 0 0 0 0.26563,-0.26562 V 0.52845431 a 0.2645835,0.2645835 0 0 0 -0.26563,-0.26367 z"
                                  id="path714"
                                  style="
                                    color: #03c0fc;
                                    font-style: normal;
                                    font-variant: normal;
                                    font-weight: normal;
                                    font-stretch: normal;
                                    font-size: medium;
                                    line-height: normal;
                                    font-family: sans-serif;
                                    font-variant-ligatures: normal;
                                    font-variant-position: normal;
                                    font-variant-caps: normal;
                                    font-variant-numeric: normal;
                                    font-variant-alternates: normal;
                                    font-variant-east-asian: normal;
                                    font-feature-settings: normal;
                                    font-variation-settings: normal;
                                    text-indent: 0;
                                    text-align: start;
                                    text-decoration: none;
                                    text-decoration-line: none;
                                    text-decoration-style: solid;
                                    text-decoration-color: #03c0fc;
                                    letter-spacing: normal;
                                    word-spacing: normal;
                                    text-transform: none;
                                    writing-mode: lr-tb;
                                    direction: ltr;
                                    text-orientation: mixed;
                                    dominant-baseline: auto;
                                    baseline-shift: baseline;
                                    text-anchor: start;
                                    white-space: normal;
                                    shape-padding: 0;
                                    shape-margin: 0;
                                    inline-size: 0;
                                    clip-rule: nonzero;
                                    display: inline;
                                    overflow: visible;
                                    visibility: visible;
                                    isolation: auto;
                                    mix-blend-mode: normal;
                                    color-interpolation: sRGB;
                                    color-interpolation-filters: linearRGB;
                                    solid-color: #03c0fc;
                                    solid-opacity: 1;
                                    vector-effect: none;
                                    fill: #03c0fc;
                                    fill-opacity: 1;
                                    fill-rule: nonzero;
                                    stroke: none;
                                    stroke-width: 0.529167;
                                    stroke-linecap: round;
                                    stroke-linejoin: miter;
                                    stroke-miterlimit: 4;
                                    stroke-dasharray: none;
                                    stroke-dashoffset: 0;
                                    stroke-opacity: 1;
                                    color-rendering: auto;
                                    image-rendering: auto;
                                    shape-rendering: auto;
                                    text-rendering: auto;
                                    enable-background: accumulate;
                                    stop-color: #03c0fc;
                                  "
                                />

                                <path
                                  d="m 1.4456487,0.79406771 c -0.6493404,0 -1.1818408,0.53042299 -1.1818408,1.17977299 v 2.1368205 c 0,0.6493502 0.5325004,1.1813233 1.1818408,1.1813233 H 3.2248685 C 3.194235,5.1638306 3.176291,5.0308032 3.176291,4.8935593 c 0,-0.94668 0.772078,-1.7187583 1.7187598,-1.7187583 0.3405214,0 0.6576695,0.1013863 0.9255231,0.2733683 V 1.9738407 c 0,-0.64935 -0.5304208,-1.17977299 -1.1797718,-1.17977299 z M 0.8053782,1.8529179 h 4.474144 c 0.00709,0.03921 0.01188,0.079325 0.01188,0.1209228 V 2.3820845 H 0.7934852 V 1.9738407 c 0,-0.041598 0.00476,-0.081712 0.01188,-0.1209228 z M 1.588275,2.7510543 H 2.1174417 A 0.2645835,0.2645835 0 0 1 2.3809905,3.0166712 0.2645835,0.2645835 0 0 1 2.1174417,3.2802211 H 1.588275 A 0.2645835,0.2645835 0 0 1 1.3226572,3.0166712 0.2645835,0.2645835 0 0 1 1.588275,2.7510543 Z m 1.5978347,0 H 3.7152764 A 0.2645835,0.2645835 0 0 1 3.9788278,3.0166712 0.2645835,0.2645835 0 0 1 3.7152764,3.2802211 H 3.1861097 A 0.2645835,0.2645835 0 0 1 2.9204945,3.0166712 0.2645835,0.2645835 0 0 1 3.1861097,2.7510543 Z M 1.588275,3.8739832 H 2.1174417 A 0.2645835,0.2645835 0 0 1 2.3809905,4.1380498 0.2645835,0.2645835 0 0 1 2.1174417,4.4036666 H 1.588275 A 0.2645835,0.2645835 0 0 1 1.3226572,4.1380498 0.2645835,0.2645835 0 0 1 1.588275,3.8739832 Z"
                                  id="path716"
                                  style="
                                    color: #03c0fc;
                                    font-style: normal;
                                    font-variant: normal;
                                    font-weight: normal;
                                    font-stretch: normal;
                                    font-size: medium;
                                    line-height: normal;
                                    font-family: sans-serif;
                                    font-variant-ligatures: normal;
                                    font-variant-position: normal;
                                    font-variant-caps: normal;
                                    font-variant-numeric: normal;
                                    font-variant-alternates: normal;
                                    font-variant-east-asian: normal;
                                    font-feature-settings: normal;
                                    font-variation-settings: normal;
                                    text-indent: 0;
                                    text-align: start;
                                    text-decoration: none;
                                    text-decoration-line: none;
                                    text-decoration-style: solid;
                                    text-decoration-color: #03c0fc;
                                    letter-spacing: normal;
                                    word-spacing: normal;
                                    text-transform: none;
                                    writing-mode: lr-tb;
                                    direction: ltr;
                                    text-orientation: mixed;
                                    dominant-baseline: auto;
                                    baseline-shift: baseline;
                                    text-anchor: start;
                                    white-space: normal;
                                    shape-padding: 0;
                                    shape-margin: 0;
                                    inline-size: 0;
                                    clip-rule: nonzero;
                                    display: inline;
                                    overflow: visible;
                                    visibility: visible;
                                    isolation: auto;
                                    mix-blend-mode: normal;
                                    color-interpolation: sRGB;
                                    color-interpolation-filters: linearRGB;
                                    solid-color: #03c0fc;
                                    solid-opacity: 1;
                                    vector-effect: none;
                                    fill: #03c0fc;
                                    fill-opacity: 1;
                                    fill-rule: nonzero;
                                    stroke: none;
                                    stroke-width: 0.529167;
                                    stroke-linecap: round;
                                    stroke-linejoin: round;
                                    stroke-miterlimit: 4;
                                    stroke-dasharray: none;
                                    stroke-dashoffset: 0;
                                    stroke-opacity: 1;
                                    paint-order: stroke fill markers;
                                    color-rendering: auto;
                                    image-rendering: auto;
                                    shape-rendering: auto;
                                    text-rendering: auto;
                                    enable-background: accumulate;
                                    stop-color: #03c0fc;
                                  "
                                />
                              </g>
                            </svg>
                          </span>

                          <span style="font-weight: bold">{{
                            'QUOTE_TEMPLATE.first_invoice' | translate
                          }}</span>
                          <span style="margin-left: 10px">{{
                            formatTimestamp(item?.date) | customDateTime
                          }}</span>
                        </div>
                        @if (item?.invoice_type !== 'single') {
                          <div>
                            <span style="margin-right: 10px">
                              <svg
                                version="1.1"
                                id="Capa_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                width="24px"
                                height="24px"
                                viewBox="0 0 50 50"
                                style="
                                  enable-background: new 0 0 50 50;
                                  fill: #03c0fc;
                                "
                                xml:space="preserve"
                              >
                                <g>
                                  <path
                                    d="M43.367,0H6.633C2.976,0,0,2.976,0,6.633v36.734C0,47.023,2.976,50,6.633,50h36.734C47.023,50,50,47.023,50,43.367V6.633
                                                    C50,2.976,47.023,0,43.367,0z M13.733,22.174c-0.325,2.54-0.505,4.461-0.546,5.76c0,0.146,0.02,0.487,0.055,1.029
                                                    c0.031,1.403,0.044,2.257,0.044,2.562v0.141c-0.03,1.105-0.312,1.794-0.841,2.07c-0.257,0.13-0.489,0.195-0.7,0.195
                                                    c-0.643,0-1.019-0.584-1.128-1.748c-0.02-0.25-0.034-0.541-0.034-0.867c0-0.279,0.007-1.053,0.027-2.328
                                                    c0.011-0.163,0.03-0.418,0.056-0.764c0.015-0.267,0.021-0.44,0.021-0.529c0.03-1.873,0.07-3.143,0.126-3.805l-1.785,0.917
                                                    c-0.356,0.163-0.646,0.246-0.876,0.246c-0.436,0-0.652-0.248-0.652-0.749c0-0.128,0.014-0.278,0.044-0.449
                                                    c0.12-0.651,0.583-1.348,1.399-2.086c0.943-0.835,1.507-1.447,1.702-1.832c0.135-0.259,0.32-0.714,0.566-1.366
                                                    c0.229-0.617,0.426-1.064,0.582-1.348c0.426-0.77,1.003-1.155,1.729-1.155c0.206,0,0.446,0.04,0.722,0.115
                                                    c0.011,0.153,0.013,0.306,0.013,0.459C14.258,17.665,14.086,19.509,13.733,22.174z M28.781,32.257
                                                    c-0.111,0.487-0.581,0.837-1.428,1.048c-0.348,0.088-0.957,0.17-1.836,0.245c-0.881,0.078-1.787,0.115-2.729,0.115
                                                    c-1.663,0-3.431-0.12-5.302-0.36c-1.146-0.148-1.839-0.584-2.058-1.313c-0.041-0.14-0.064-0.278-0.064-0.413
                                                    c0-0.586,0.405-1.163,1.206-1.727c3.191-2.225,5.606-4.49,7.261-6.79c0.29-0.401,0.447-0.779,0.463-1.138v-0.052
                                                    c0-0.298-0.093-0.551-0.287-0.757c-0.275-0.274-0.636-0.413-1.065-0.413c-0.301,0-0.647,0.062-1.043,0.193
                                                    c-0.977,0.328-1.856,1.195-2.634,2.598c-0.113,0.223-0.317,0.391-0.608,0.501c-0.194,0.078-0.402,0.116-0.624,0.116
                                                    c-0.064,0-0.129-0.003-0.188-0.011c-0.307-0.039-0.542-0.149-0.707-0.332c-0.136-0.154-0.202-0.329-0.202-0.529
                                                    c0-0.078,0.006-0.153,0.026-0.228c0.28-1.441,1.121-2.656,2.508-3.648c1.293-0.909,2.661-1.366,4.103-1.366h0.188
                                                    c1.453,0,2.5,0.573,3.131,1.708c0.316,0.573,0.469,1.173,0.469,1.807c0,0.56-0.113,1.143-0.352,1.751
                                                    c-0.51,1.281-1.558,2.595-3.136,3.945c-2.055,1.744-3.254,2.832-3.599,3.26c1.692,0.193,3.061,0.317,4.103,0.371h0.063
                                                    c0.275,0,0.834-0.062,1.682-0.186c0.45-0.065,0.828-0.098,1.135-0.098c0.25,0,0.451,0.02,0.596,0.063
                                                    c0.512,0,0.836,0.185,0.965,0.553c0.035,0.113,0.05,0.246,0.05,0.396C28.865,31.77,28.836,32,28.781,32.257z M42.438,30.532
                                                    c-0.242,1.092-0.982,1.916-2.22,2.472c-0.967,0.441-2.06,0.662-3.276,0.662h-0.094c-1.383,0-2.787-0.291-4.222-0.872
                                                    c-1.668-0.681-2.772-1.56-3.317-2.632c-0.187-0.372-0.281-0.68-0.281-0.926c0-0.064,0.005-0.127,0.015-0.185
                                                    c0.065-0.271,0.278-0.571,0.644-0.907c0.127-0.104,0.276-0.158,0.457-0.158c0.256,0,0.56,0.111,0.909,0.334
                                                    c0.08,0.048,0.435,0.315,1.052,0.803c0.891,0.697,1.898,1.238,3.037,1.609c0.771,0.254,1.479,0.382,2.108,0.382
                                                    c0.446,0,0.862-0.062,1.239-0.185c0.561-0.197,0.878-0.443,0.959-0.75c0.009-0.059,0.015-0.117,0.015-0.168
                                                    c0-0.236-0.11-0.494-0.344-0.773c-0.562-0.668-1.279-1.131-2.156-1.383c-1.282-0.375-2.146-0.72-2.59-1.03
                                                    c-0.376-0.271-0.562-0.556-0.562-0.854c0-0.388,0.317-0.793,0.959-1.214c0.08-0.056,0.695-0.376,1.85-0.97
                                                    c0.681-0.346,1.195-0.761,1.547-1.243c0.062-0.118,0.221-0.375,0.477-0.773v-0.053c0-0.271-0.062-0.486-0.183-0.645
                                                    c-0.097-0.065-0.235-0.098-0.427-0.098c-0.251,0-0.565,0.063-0.946,0.186c-0.12,0.043-0.801,0.321-2.045,0.836
                                                    c-0.815,0.341-1.422,0.512-1.813,0.512h-0.035c-0.576-0.022-0.867-0.349-0.867-0.977v-0.063c0-0.896,0.91-1.664,2.724-2.297
                                                    c1.394-0.48,2.565-0.721,3.522-0.721h0.098c1.172,0,1.984,0.316,2.432,0.949c0.25,0.358,0.377,0.79,0.377,1.295
                                                    c0,0.372-0.064,0.78-0.195,1.226c-0.194,0.691-0.6,1.345-1.213,1.964c-0.139,0.14-0.412,0.394-0.817,0.756
                                                    c-0.351,0.315-0.604,0.554-0.749,0.714c1.059,0.41,1.993,1.068,2.814,1.98c0.787,0.874,1.184,1.736,1.184,2.588
                                                    C42.5,30.128,42.479,30.331,42.438,30.532z"
                                  />
                                </g>
                              </svg>
                            </span>
                            <span style="font-weight: bold"
                              >{{
                                'QUOTE_TEMPLATE.Number of times' | translate
                              }}:</span
                            >
                            <span style="margin-left: 10px">{{
                              item?.send_number || 0
                            }}</span>
                          </div>
                        }
                        @if (item?.frequency) {
                          <div>
                            <span style="margin-right: 10px">
                              <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                width="24px"
                                height="24px"
                                viewBox="0 0 512 512"
                                style="
                                  enable-background: new 0 0 512 512;
                                  fill: #03c0fc;
                                "
                                xml:space="preserve"
                              >
                                <g>
                                  <g>
                                    <path
                                      d="M353.103,224.804H325.03L291.139,55.521c-0.847-4.233-4.603-7.149-8.943-7.005c-4.314,0.14-7.893,3.421-8.463,7.699
                                                        l-46.504,348.801l-59.726-261.292c-0.902-3.947-4.374-6.769-8.422-6.853c-3.962-0.04-7.635,2.599-8.699,6.506l-45.879,168.222
                                                        l-34.469-89.792c-1.311-3.408-4.586-5.831-8.239-5.831H8.828c-4.875,0-8.828,3.953-8.828,8.828c0,4.875,3.953,8.828,8.828,8.828
                                                        h46.903l41.961,109.273c1.37,3.562,4.876,5.914,8.684,5.735c3.811-0.193,7.068-2.769,8.071-6.451l43.695-160.192l62.769,274.627
                                                        c0.921,4.029,4.504,6.866,8.601,6.866c0.137,0,0.274-0.001,0.41-0.008c4.266-0.195,7.779-3.416,8.344-7.649l45.958-344.684
                                                        l24.912,124.387c0.825,4.126,4.448,6.924,8.656,6.924h35.31c4.875,0,8.828-3.953,8.828-8.828
                                                        C361.931,228.756,357.978,224.804,353.103,224.804z"
                                    />
                                  </g>
                                </g>
                                <g>
                                  <g>
                                    <path
                                      d="M441.379,224.804h-44.138c-4.875,0-8.828,3.953-8.828,8.828c0,4.875,3.953,8.828,8.828,8.828h44.138
                                                        c4.875,0,8.828-3.953,8.828-8.828C450.207,228.756,446.254,224.804,441.379,224.804z"
                                    />
                                  </g>
                                </g>
                                <g>
                                  <g>
                                    <path
                                      d="M503.172,224.804H476.69c-4.875,0-8.828,3.953-8.828,8.828c0,4.875,3.953,8.828,8.828,8.828h26.483
                                                        c4.875,0,8.828-3.953,8.828-8.828C512,228.756,508.047,224.804,503.172,224.804z"
                                    />
                                  </g>
                                </g>
                              </svg>
                            </span>
                            <span style="font-weight: bold"
                              >{{
                                'QUOTE_TEMPLATE.Frequency' | translate
                              }}:</span
                            >
                            <span style="margin-left: 10px"
                              >{{
                                getTranslatedText(
                                  'COMMON.' + item?.frequency
                                ) ||
                                  item?.frequency ||
                                  ''
                              }}
                            </span>
                          </div>
                        }
                        @if (item?.last_date) {
                          <div>
                            <span style="margin-right: 10px">
                              <svg
                                height="24px"
                                width="24px"
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 512 512"
                                xml:space="preserve"
                                fill="#000000"
                              >
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g
                                  id="SVGRepo_tracerCarrier"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                ></g>
                                <g id="SVGRepo_iconCarrier">
                                  <path
                                    style="fill: #03c0fc"
                                    d="M357.517,35.31H233.931c0,9.75-7.905,17.655-17.655,17.655c-9.75,0-17.655-7.905-17.655-17.655 H75.034c-14.626,0-26.483,11.857-26.483,26.483v370.759c0,14.626,11.857,26.483,26.483,26.483h282.483 c14.626,0,26.483-11.857,26.483-26.483V61.793C384,47.167,372.143,35.31,357.517,35.31z"
                                  ></path>
                                  <path
                                    style="fill: #03c0fc"
                                    d="M375.172,317.793c-2.98,0-5.909,0.204-8.828,0.446V61.793c0-4.875-3.953-8.828-8.828-8.828h-44.138 c-4.875,0-8.828-3.953-8.828-8.828V35.31h-70.621c0,9.75-7.905,17.655-17.655,17.655c-9.75,0-17.655-7.905-17.655-17.655H128v8.828 c0,4.875-3.953,8.828-8.828,8.828H75.034c-4.875,0-8.828,3.953-8.828,8.828v370.759c0,4.875,3.953,8.828,8.828,8.828h195.75 c1.05,6.07,2.602,11.97,4.615,17.655h82.119c14.626,0,26.483-11.857,26.483-26.483V318.239 C381.081,317.997,378.153,317.793,375.172,317.793z"
                                  ></path>
                                  <path
                                    style="fill: #f1f4fb"
                                    d="M339.862,423.724H92.69c-4.875,0-8.828-3.953-8.828-8.828V79.448c0-4.875,3.953-8.828,8.828-8.828 h247.172c4.875,0,8.828,3.953,8.828,8.828v335.448C348.69,419.772,344.737,423.724,339.862,423.724z"
                                  ></path>
                                  <path
                                    style="fill: #e4eaf8"
                                    d="M348.69,414.897v-93.632c-45.664,11.776-79.448,53.117-79.448,102.46h70.621 C344.737,423.724,348.69,419.772,348.69,414.897z"
                                  ></path>
                                  <path
                                    style="fill: #03c0fc"
                                    d="M269.241,17.655h-22.552C240.573,7.145,229.312,0,216.276,0s-24.297,7.145-30.413,17.655H163.31 c-9.75,0-17.655,7.904-17.655,17.655v35.31c0,4.875,3.953,8.828,8.828,8.828h123.586c4.875,0,8.828-3.953,8.828-8.828V35.31 C286.897,25.559,278.991,17.655,269.241,17.655z M216.276,48.552c-7.313,0-13.241-5.929-13.241-13.241s5.929-13.241,13.241-13.241 s13.241,5.929,13.241,13.241S223.588,48.552,216.276,48.552z"
                                  ></path>
                                  <path
                                    style="fill: #03c0fc"
                                    d="M154.483,79.448h123.586c4.875,0,8.828-3.953,8.828-8.828l0,0c0-4.875-3.953-8.828-8.828-8.828 H154.483c-4.875,0-8.828,3.953-8.828,8.828l0,0C145.655,75.496,149.608,79.448,154.483,79.448z"
                                  ></path>
                                  <circle
                                    style="fill: #03c0fc"
                                    cx="375.172"
                                    cy="423.724"
                                    r="88.276"
                                  ></circle>
                                  <path
                                    style="fill: #03c0fc"
                                    d="M419.31,494.345c-48.754,0-88.276-39.522-88.276-88.276c0-28.622,13.683-53.987,34.797-70.116 c-44.36,4.668-78.935,42.174-78.935,87.772c0,48.754,39.522,88.276,88.276,88.276c20.131,0,38.627-6.815,53.479-18.159 C425.58,494.164,422.466,494.345,419.31,494.345z"
                                  ></path>
                                  <path
                                    style="fill: #ffffff"
                                    d="M357.517,467.862c-2.259,0-4.518-0.862-6.241-2.586l-35.31-35.31c-3.448-3.448-3.448-9.035,0-12.483 c3.448-3.448,9.035-3.448,12.483,0l29.068,29.07L413.069,391c3.448-3.448,9.035-3.448,12.483,0s3.448,9.035,0,12.483l-61.793,61.793 C362.035,467,359.776,467.862,357.517,467.862z"
                                  ></path>
                                  <g>
                                    <path
                                      style="fill: #03c0fc"
                                      d="M180.966,174.357v-32.258c10.952,2.036,17.655,7.501,17.655,11.556c0,4.879,3.948,8.828,8.828,8.828 s8.828-3.948,8.828-8.828c0-14.795-14.932-26.766-35.31-29.481v-0.588c0-4.879-3.948-8.828-8.828-8.828 c-4.879,0-8.828,3.948-8.828,8.828v0.588C142.932,126.889,128,138.86,128,153.655c0,20.945,19.346,29.039,35.31,33.919v32.258 c-10.952-2.036-17.655-7.501-17.655-11.556c0-4.879-3.948-8.828-8.828-8.828c-4.879,0-8.828,3.948-8.828,8.828 c0,14.795,14.932,26.766,35.31,29.481v0.588c0,4.879,3.948,8.828,8.828,8.828c4.879,0,8.828-3.948,8.828-8.828v-0.588 c20.378-2.714,35.31-14.686,35.31-29.481C216.276,187.331,196.93,179.236,180.966,174.357z M145.655,153.655 c0-4.055,6.703-9.521,17.655-11.556v26.792C150.303,164.252,145.655,160.042,145.655,153.655z M180.966,219.832v-26.792 c13.007,4.639,17.655,8.849,17.655,15.235C198.621,212.331,191.917,217.796,180.966,219.832z"
                                    ></path>
                                    <path
                                      style="fill: #03c0fc"
                                      d="M295.724,150.069h-44.138c-4.879,0-8.828-3.948-8.828-8.828s3.948-8.828,8.828-8.828h44.138 c4.879,0,8.828,3.948,8.828,8.828S300.604,150.069,295.724,150.069z"
                                    ></path>
                                  </g>
                                  <g>
                                    <path
                                      style="fill: #959cb5"
                                      d="M278.069,185.379h-26.483c-4.879,0-8.828-3.948-8.828-8.828c0-4.879,3.948-8.828,8.828-8.828h26.483 c4.879,0,8.828,3.948,8.828,8.828C286.897,181.431,282.948,185.379,278.069,185.379z"
                                    ></path>
                                    <path
                                      style="fill: #959cb5"
                                      d="M295.724,220.69h-44.138c-4.879,0-8.828-3.948-8.828-8.828c0-4.879,3.948-8.828,8.828-8.828h44.138 c4.879,0,8.828,3.948,8.828,8.828C304.552,216.742,300.604,220.69,295.724,220.69z"
                                    ></path>
                                  </g>
                                  <g>
                                    <path
                                      style="fill: #03c0fc"
                                      d="M154.483,300.138h-17.655c-4.879,0-8.828-3.948-8.828-8.828c0-4.879,3.948-8.828,8.828-8.828h17.655 c4.879,0,8.828,3.948,8.828,8.828C163.31,296.19,159.362,300.138,154.483,300.138z"
                                    ></path>
                                    <path
                                      style="fill: #03c0fc"
                                      d="M154.483,370.759h-17.655c-4.879,0-8.828-3.948-8.828-8.828s3.948-8.828,8.828-8.828h17.655 c4.879,0,8.828,3.948,8.828,8.828S159.362,370.759,154.483,370.759z"
                                    ></path>
                                    <path
                                      style="fill: #03c0fc"
                                      d="M154.483,335.448h-17.655c-4.879,0-8.828-3.948-8.828-8.828c0-4.879,3.948-8.828,8.828-8.828h17.655 c4.879,0,8.828,3.948,8.828,8.828C163.31,331.5,159.362,335.448,154.483,335.448z"
                                    ></path>
                                  </g>
                                  <g>
                                    <path
                                      style="fill: #959cb5"
                                      d="M295.724,300.138H189.793c-4.879,0-8.828-3.948-8.828-8.828c0-4.879,3.948-8.828,8.828-8.828 h105.931c4.879,0,8.828,3.948,8.828,8.828C304.552,296.19,300.604,300.138,295.724,300.138z"
                                    ></path>
                                    <path
                                      style="fill: #959cb5"
                                      d="M269.241,370.759h-79.448c-4.879,0-8.828-3.948-8.828-8.828s3.948-8.828,8.828-8.828h79.448 c4.879,0,8.828,3.948,8.828,8.828S274.121,370.759,269.241,370.759z"
                                    ></path>
                                    <path
                                      style="fill: #959cb5"
                                      d="M295.724,335.448H189.793c-4.879,0-8.828-3.948-8.828-8.828c0-4.879,3.948-8.828,8.828-8.828 h105.931c4.879,0,8.828,3.948,8.828,8.828C304.552,331.5,300.604,335.448,295.724,335.448z"
                                    ></path>
                                  </g>
                                </g>
                              </svg>
                            </span>
                            <span style="font-weight: bold"
                              >{{
                                'QUOTE_TEMPLATE.Last invoice' | translate
                              }}:</span
                            >
                            <span style="margin-left: 10px">{{
                              formatTimestamp(item?.last_date) | customDateTime
                            }}</span>
                          </div>
                        }
                        @if (item?.invoice_type !== 'single') {
                          <div class="flex">
                            <span
                              style="
                                margin-right: 10px;
                                height: 24px;
                                width: 24px;
                              "
                            >
                              <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                viewBox="0 0 488.9 488.9"
                                style="enable-background: new 0 0 488.9 488.9"
                                xml:space="preserve"
                              >
                                <g>
                                  <g>
                                    <g id="XMLID_2160_">
                                      <path
                                        id="XMLID_2161_"
                                        style="fill: #03c0fc"
                                        d="M364.7,461.2l18.6-18.6l18.6,18.6l18.6,18.6l18.6-18.6V152.3
                                                            c0-17.8-14.4-32.3-32.3-32.3H146.7c17.8,0,32.3,14.4,32.3,32.3v308.8l18.6,18.6l18.6-18.6l18.6-18.6l18.6,18.6l18.6,18.6
                                                            l18.6-18.6l18.6-18.6l18.6,18.6l18.6,18.6L364.7,461.2z"
                                      />
                                    </g>
                                    <path
                                      d="M225.2,199h169.2c5,0,9.1-4.1,9.1-9.1s-4.1-9.1-9.1-9.1H225.2c-5,0-9.1,4.1-9.1,9.1S220.2,199,225.2,199z"
                                    />
                                    <path
                                      d="M225.2,247.3h122.9c5,0,9.1-4.1,9.1-9.1s-4.1-9.1-9.1-9.1H225.2c-5,0-9.1,4.1-9.1,9.1
                                                        C216.1,243.3,220.2,247.3,225.2,247.3z"
                                    />
                                    <path
                                      d="M225.2,291.6h169.2c5,0,9.1-4.1,9.1-9.1s-4.1-9.1-9.1-9.1H225.2c-5,0-9.1,4.1-9.1,9.1
                                                        C216.1,287.6,220.2,291.6,225.2,291.6z"
                                    />
                                    <path
                                      d="M241.3,323.9h-16.1c-5,0-9.1,4.1-9.1,9.1s4.1,9.1,9.1,9.1h16.1c5,0,9.1-4.1,9.1-9.1S246.3,323.9,241.3,323.9z"
                                    />
                                    <path
                                      d="M241.3,368.2h-16.1c-5,0-9.1,4.1-9.1,9.1s4.1,9.1,9.1,9.1h16.1c5,0,9.1-4.1,9.1-9.1C250.3,372.2,246.3,368.2,241.3,368.2z
                                                        "
                                    />
                                    <path
                                      d="M394.4,323.9H277.5c-5,0-9.1,4.1-9.1,9.1s4.1,9.1,9.1,9.1h116.9c5,0,9.1-4.1,9.1-9.1S399.4,323.9,394.4,323.9z"
                                    />
                                    <path
                                      d="M357.1,377.2c0-5-4.1-9.1-9.1-9.1h-70.5c-5,0-9.1,4.1-9.1,9.1s4.1,9.1,9.1,9.1H348C353,386.3,357.1,382.2,357.1,377.2z"
                                    />
                                    <path
                                      d="M339.7,486.2c3.5,3.5,9.3,3.5,12.8,0l30.8-30.8l30.8,30.8c1.8,1.8,4.1,2.7,6.4,2.7s4.6-0.9,6.4-2.7l18.6-18.6
                                                        c1.7-1.7,2.7-4,2.7-6.4V152.3c0-22.8-18.5-41.3-41.3-41.3h-69.5V9.1c0-5-4.1-9.1-9.1-9.1H49.8c-5,0-9.1,4.1-9.1,9.1v308.8
                                                        c0,22.8,18.5,41.3,41.3,41.3h52.4c5,0,9.1-4.1,9.1-9.1s-4.1-9.1-9.1-9.1h-18.2c4.5-6.6,7.2-14.6,7.2-23.2V152.3
                                                        c0-12.8,10.4-23.2,23.2-23.2c12.8,0,23.2,10.4,23.2,23.2v308.8c0,0.6,0.1,1.2,0.2,1.8c0.1,0.4,0.2,0.7,0.3,1.1
                                                        c0.1,0.2,0.1,0.4,0.2,0.6c0.2,0.4,0.4,0.8,0.6,1.1c0.1,0.1,0.1,0.3,0.2,0.4c0.3,0.5,0.7,1,1.1,1.4l18.6,18.6
                                                        c3.5,3.5,9.3,3.5,12.8,0l30.8-30.8l30.8,30.8c3.5,3.5,9.3,3.5,12.8,0l30.8-30.8L339.7,486.2z M105.3,152.3v165.6
                                                        c0,12.8-10.4,23.2-23.2,23.2s-23.2-10.4-23.2-23.2V18.1h260.4V111H146.6C123.8,111,105.3,129.5,105.3,152.3z M271.8,466.9
                                                        L241,436.1c-1.8-1.8-4.1-2.7-6.4-2.7c-2.3,0-4.6,0.9-6.4,2.7l-30.8,30.8l-9.5-9.5V152.3c0-1.3-0.1-2.6-0.2-3.8
                                                        c0-0.4-0.1-0.7-0.1-1.1c-0.1-0.9-0.2-1.8-0.4-2.7c-0.1-0.4-0.1-0.7-0.2-1.1c-0.2-1.1-0.5-2.3-0.9-3.4c0-0.1,0-0.1-0.1-0.2
                                                        c-0.4-1.2-0.8-2.3-1.3-3.4c-0.1-0.3-0.3-0.6-0.4-1c-0.4-0.8-0.7-1.6-1.2-2.4c-0.2-0.3-0.3-0.6-0.5-1c-0.5-0.9-1.1-1.9-1.7-2.8
                                                        c-0.1-0.1-0.1-0.2-0.2-0.3c0,0,0,0,0-0.1h225.9c12.8,0,23.2,10.4,23.2,23.2v305.2l-9.5,9.5l-30.8-30.8c-3.5-3.5-9.3-3.5-12.8,0
                                                        l-30.8,30.8l-30.5-30.7c-3.5-3.5-9.3-3.5-12.8,0L271.8,466.9z"
                                    />
                                  </g>
                                </g>
                              </svg>
                            </span>
                            <span style="font-weight: bold"
                              >{{
                                'QUOTE_TEMPLATE.Invoice Type' | translate
                              }}:</span
                            >
                            <span style="margin-left: 10px">{{
                              item?.id_sequence || ''
                            }}</span>
                          </div>
                        }

                        <!-- <div><span>{{ 'Last invoice:' }}</span>{{ item?.created_at }}</div> -->
                      </div>
                    </span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <button
        class="btn btn-1 bg-1 p-3 w-100 color-00 h5 shadow-sm rounded-pill"
        (click)="closeDialog()"
      >
        {{ 'COMMON.Close' | translate }}
      </button>
    </div>
  </div>
}
